// Adresy zewnętrznych usług — z VUE_APP_* z produkcyjnymi wartościami domyślnymi.
export const API_URL = process.env.VUE_APP_API_URL || 'https://api.sledzgps.pl'
export const WS_URL = process.env.VUE_APP_WS_URL || 'https://websocket.sledzgps.com'
export const ASSETS_BASE_URL = process.env.VUE_APP_ASSETS_BASE_URL || 'https://sledzgps.pl'
